import React from 'react';
import "./../styles/styles.css";

const PreLoader = () => {
  return (
   <div className="animatingPreLoader"></div>
  )
}

export default PreLoader